 <app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="qualificationsProfessionnelles.precisions" 
 
[label]="step8.getprecisions"
[type]="'text'" [rule]="'minSize_5|maxSize_2000'"
[name]="getUid()+'_SepAtt_precisions'">
</app-form-input>
